import './HelpNode.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react';

const HelpNode = ({ isSelected, nodeId, title }) => (
  <div className={isSelected ? 'aa-help-node__selected' : 'aa-help-node'}>
    <List.Item>
      <a href={`/help/${nodeId}`}>{title}</a>
    </List.Item>
  </div>
);

HelpNode.propTypes = {
  isSelected: PropTypes.bool,
  nodeId: PropTypes.string,
  title: PropTypes.string,
};

export default HelpNode;
